import { NavItem } from '@lib/components/Menu/Menu';
import _without from 'lodash/without';
import {
  NavItemArgs,
  getHomeNavItem,
  getDashboardNavItem,
  getWorkflowsNavItem,
  getInterventionsNavItem,
  getSitesNavItem,
  getUsersNavItem,
  getAssetsNavItem,
  getDocumentationNavItem,
  getSettingsNavItems,
} from './navItems';

export type { NavItemArgs, UrlParams } from './navItems';

export { getSettingsNavItems };

export default function getNavItems(args: NavItemArgs) {
  return _without(
    [
      getHomeNavItem(args),
      getDashboardNavItem(args),
      getWorkflowsNavItem(args),
      getInterventionsNavItem(args),
      getSitesNavItem(args),
      getUsersNavItem(args),
      getAssetsNavItem(args),
      getDocumentationNavItem(args),
    ],
    undefined,
  ) as NavItem<undefined>[];
}
